/**
 * Who a period or obligation is allocated to (D3), as resolved by the server.
 *
 * The source shows only where it is worth a second look: an allocation that
 * came from imported initials is a guess a manager has not confirmed yet, and
 * initials nobody holds are a data problem, so both say so. A person allocated
 * explicitly is just their name.
 */

import type { Allocation } from '../api'
import { Tooltip } from './Tooltip'

export function AllocationLabel({
  allocation,
  override = false,
}: {
  allocation: Allocation | null
  /** True when this one period carries its own allocation. */
  override?: boolean
}) {
  if (allocation === null) {
    return <span className="text-[12.5px] text-eq-helper">Unallocated</span>
  }
  if (allocation.source === 'unmatched') {
    return (
      <Tooltip content="Imported initials that no one in User access holds. Record the person's initials there, or allocate the work." focusable={false}>
        <span className="rounded-eq-pill bg-eq-warning-bg px-2 py-0.5 text-[12px] text-eq-warning">
          {allocation.name}?
        </span>
      </Tooltip>
    )
  }
  return (
    <span className="text-[13px]">
      {allocation.name}
      {allocation.source === 'initials' && (
        <Tooltip content="From the imported SmartPractice initials. A manager can confirm or change it on the obligation's matrix." focusable={false} className="ml-1 inline-flex">
          <span className="text-[11.5px] text-eq-helper">(initials)</span>
        </Tooltip>
      )}
      {override && (
        <Tooltip content="This period is allocated separately from the client's standing allocation." focusable={false} className="ml-1 inline-flex">
          <span className="text-[11.5px] text-eq-helper">(this period)</span>
        </Tooltip>
      )}
    </span>
  )
}
